import React from 'react';
import ReactDom from 'react-dom/client';
import HomePageFirstSection from '@components/home/HomePageFirstSection';
import { HomePageMenuItem } from '@components/home/HomePageMenuItemComp';
import { MainSliderThumbnail } from '@components/home/HomeMainSlider';
import config from '@config';
import { MiniSliderThumbnail } from '@components/home/HomeMiniSlider';
import { uniqueId } from '@xFrame4/common/Functions';

export class HomePageHelper
{
    setup()
    {
        // read the JSON data: home_menu
        let jsonElementHomeMenu = document.getElementById('home_menu');
        let homePageMenuItems: HomePageMenuItem[] = [];
        if (jsonElementHomeMenu) 
        {
            let jsonHomeMenu = JSON.parse(jsonElementHomeMenu.textContent ?? '');
            console.log('Home menu data:', jsonHomeMenu);
            homePageMenuItems = jsonHomeMenu;
        }

        // read the JSON data: main_slider
        let jsonElementMainSlider = document.getElementById('main_slider');
        let mainSliderThumbnails: MainSliderThumbnail[] = [];
        if (jsonElementMainSlider) 
        {
            let jsonMainSlider = JSON.parse(jsonElementMainSlider.textContent ?? '');
            console.log('Main slider data:', jsonMainSlider);

            for (let i = 0; i < jsonMainSlider.length; i++) 
            {
                let mainSliderThumbnail: MainSliderThumbnail = {
                    title: jsonMainSlider[i].title,
                    subtitle: jsonMainSlider[i].subtitle,
                    ctaText: jsonMainSlider[i].cta_text,
                    url: jsonMainSlider[i].url,
                    image: {
                        url: config.defaultPublicDirBaseUrl + 'media/_dope/main_slider/' + jsonMainSlider[i].image,
                        width: 1100,
                        height: 474
                    },
                    alterImage: {
                        url: config.defaultPublicDirBaseUrl + 'media/_dope/main_slider/' + jsonMainSlider[i].alter_image,
                        width: 500,
                        height: 500
                    }
                };
                mainSliderThumbnails.push(mainSliderThumbnail);
            }
        }

        // read the JSON data: mini_slider
        let jsonElementMiniSlider = document.getElementById('mini_slider');
        let miniSliderThumbnails: MiniSliderThumbnail[] = [];
        if (jsonElementMiniSlider) 
        {
            let jsonMiniSlider = JSON.parse(jsonElementMiniSlider.textContent ?? '');
            console.log('Mini slider data:', jsonMiniSlider);

            for (let i = 0; i < jsonMiniSlider.length; i++)
            {
                let miniSliderThumbnail: MiniSliderThumbnail = {
                    name: jsonMiniSlider[i].name,
                    text1: jsonMiniSlider[i].text_1,
                    text2: jsonMiniSlider[i].text_2,
                    url: jsonMiniSlider[i].url,
                    image: {
                        url: config.defaultPublicDirBaseUrl + 'media/_dope/mini_slider/' + jsonMiniSlider[i].image,
                        width: 350,
                        height: 230
                    },
                    alterImage: {
                        url: config.defaultPublicDirBaseUrl + 'media/_dope/mini_slider/' + jsonMiniSlider[i].alter_image,
                        width: 300,
                        height: 475
                    }
                };
                miniSliderThumbnails.push(miniSliderThumbnail);
            }
        }

        // setup the React root element and render the Home page React components
        if (jsonElementHomeMenu && jsonElementMainSlider && jsonElementMiniSlider) 
        {
            let reactRootElement = document.getElementById('home-page-first-section-react-root');
            if (reactRootElement) 
            {
                let reactRoot = ReactDom.createRoot(reactRootElement);
                reactRoot.render(
                    <HomePageFirstSection 
                        menuItems={homePageMenuItems}
                        mainSliderThumbnails={mainSliderThumbnails}
                        miniSliderThumbnails={miniSliderThumbnails}
                    />
                );
            }
        }
    }
}

export default HomePageHelper;